(function ($) {
	var $videoOverlay = $('.js-overlay-rb-play');

	var playVideo = function (video) {
		video.addClass('play');
		var dataSrc = video.find('iframe').attr('src');
		dataSrc = dataSrc.split('?')[0];
		var dataSrcWithAutoplay = dataSrc + '?auto_play=true&rel=0';

		video.find('iframe').attr('src', dataSrcWithAutoplay);
	};

	$videoOverlay.on('click', function () {
		$(this).addClass('hidden');

		if ($(this).parents('.js-video-popup').length) {
			$(this).closest('.js-video-popup').addClass('playing');
		}
		var video = $(this).closest('.js-video-iframe');

		playVideo(video);
	});

})(jQuery);
